import { Entity, LoadingState } from '@zdr-tools/zdr-entities';
/** Whether the login site can offer "Continue with Google". */
export var GoogleSignInAvailability;
(function (GoogleSignInAvailability) {
    /** Nothing has asked for Google yet. */
    GoogleSignInAvailability["UNKNOWN"] = "UNKNOWN";
    /** The client id and Google's script are loading. */
    GoogleSignInAvailability["PREPARING"] = "PREPARING";
    /** Google's button may be rendered. */
    GoogleSignInAvailability["AVAILABLE"] = "AVAILABLE";
    /** Google could not be prepared; the email code still works. */
    GoogleSignInAvailability["UNAVAILABLE"] = "UNAVAILABLE";
})(GoogleSignInAvailability || (GoogleSignInAvailability = {}));
const LOADING_STATE_BY_AVAILABILITY = {
    [GoogleSignInAvailability.UNKNOWN]: LoadingState.IDLE,
    [GoogleSignInAvailability.PREPARING]: LoadingState.LOADING,
    [GoogleSignInAvailability.AVAILABLE]: LoadingState.DONE,
    [GoogleSignInAvailability.UNAVAILABLE]: LoadingState.ERROR
};
/** Whether Google's sign-in could be prepared on this page: one way, from not known to available or unavailable. */
export class GoogleAvailability extends Entity {
    status;
    loadingState;
    constructor(initialStatus) {
        super('google-availability');
        this.status = this.createPropEventBroker('status', initialStatus);
        this.loadingState = this.createPropEventBroker('loadingState', LOADING_STATE_BY_AVAILABILITY[initialStatus]);
    }
    getEntityName() {
        return 'GoogleAvailability';
    }
    markPreparing() {
        this.assertStatus(GoogleSignInAvailability.UNKNOWN, 'markPreparing');
        this.moveTo(GoogleSignInAvailability.PREPARING);
    }
    markAvailable() {
        this.assertStatus(GoogleSignInAvailability.PREPARING, 'markAvailable');
        this.moveTo(GoogleSignInAvailability.AVAILABLE);
    }
    markUnavailable() {
        this.assertStatus(GoogleSignInAvailability.PREPARING, 'markUnavailable');
        this.moveTo(GoogleSignInAvailability.UNAVAILABLE);
    }
    assertStatus(expectedStatus, methodName) {
        if (this.status.get() !== expectedStatus) {
            throw new Error(`${methodName} is allowed only while Google sign-in is ${expectedStatus}, not ${this.status.get()}`);
        }
    }
    moveTo(status) {
        this.status.set(status);
        this.loadingState.set(LOADING_STATE_BY_AVAILABILITY[status]);
    }
}
//# sourceMappingURL=GoogleAvailability.js.map